import { render, staticRenderFns } from "./AppPlayerTeamFantasy.vue?vue&type=template&id=3c968933&"
import script from "./AppPlayerTeamFantasy.vue?vue&type=script&lang=js&"
export * from "./AppPlayerTeamFantasy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports